import { createSlice } from '@reduxjs/toolkit';
import { generateReduxKeys } from '../../utils';
import _ from 'lodash';

const initialState = generateReduxKeys({
  contacts: [],
  contactsPagination: null,
  activeContacts: [],
  activeContactsPagination: null,
  chatContacts: [],
  chatContactsPagination: null,
  archivedContacts: [],
  archivedPagination: null,
  blockedContacts: [],
  blockedPagination: null,
});

const contactsSlice = createSlice({
  name: 'contacts',
  initialState,
  reducers: {
    setActiveStatus: (state, action) => {
      const newStatuses = Array.isArray(action.payload) ? action.payload : [action.payload];
      state.activeStatus = Array.from(new Set([...state.activeStatus, ...newStatuses]));
    },
    setContacts: (state, action) => {
      const { contacts, pagination } = action.payload;
      localStorage.setItem('contacts', JSON.stringify(contacts));
      localStorage.setItem('contactsPagination', JSON.stringify(pagination));
      state.contacts = contacts;
      state.contactsPagination = pagination;
    },
    setChatContacts: (state, action) => {
      const { contacts, pagination } = action.payload;
      localStorage.setItem('chatContacts', JSON.stringify(contacts));
      localStorage.setItem('chatContactsPagination', JSON.stringify(pagination));
      state.chatContacts = contacts;
      state.chatContactsPagination = pagination;
    },
    setActiveContacts: (state, action) => {
      const { contacts, pagination } = action.payload;
      localStorage.setItem('activeContacts', JSON.stringify(contacts));
      localStorage.setItem('activeContactsPagination', JSON.stringify(pagination));
      state.activeContacts = contacts;
      state.activeContactsPagination = pagination;
    },
    setArchivedContacts: (state, action) => {
      const { contacts, pagination } = action.payload;
      localStorage.setItem('archivedContacts', JSON.stringify(contacts));
      localStorage.setItem('archivedPagination', JSON.stringify(pagination));
      state.archivedContacts = contacts;
      state.archivedPagination = pagination;
    },
    setBlockedContacts: (state, action) => {
      const { contacts, pagination } = action.payload;
      localStorage.setItem('blockedContacts', JSON.stringify(contacts));
      localStorage.setItem('blockedPagination', JSON.stringify(pagination));
      state.blockedContacts = contacts;
      state.blockedPagination = pagination;
    },
    updateLastMessage: (state, action) => {
      const { contact_id, message, createdAt } = action.payload;
      const contactIndex = state.chatContacts.findIndex(
        (contact) => String(contact.id) === String(contact_id)
      );
      if (contactIndex !== -1) {
        const contact = state.chatContacts[contactIndex];
        contact.last_message = message;
        contact.last_message_time = createdAt;
        contact.unread_count = action.payload?.is_unread ? (contact.unread_count || 0) + 1 : 0;
        contact.isReceivedMessage = action.payload?.isReceivedMessage;
      }

      state.chatContacts = _.orderBy(
        state.chatContacts,
        [
          (c) => (c.is_pinned ? 0 : 1),
          (c) => (c.is_pinned ? new Date(c.pinned_at) : -new Date(c.last_message_time))
        ],
        ["asc", "asc"]
      );
    },
    updateUnreadCount: (state, action) => {
      const { contact_id, count, unread } = action.payload;
      const contactIndex = state.chatContacts.findIndex(
        (contact) => String(contact.id) === String(contact_id)
      );
      if (contactIndex !== -1) {
        const contact = state.chatContacts[contactIndex];
        contact.unread_count = count;
        state.chatContacts[contactIndex] = contact;
      }

      if (unread) {
        state.chatContacts = state.chatContacts.filter(
          (c) => c.unread_count && c.unread_count > 0
        );
      }
    },
    appendNewContact: (state, action) => {
      const { contact, chat_contact } = action.payload;
      state.contacts = _.orderBy(_.concat(state.contacts, contact), ['name'], ['asc']);
      state.chatContacts = _.orderBy(
        _.concat(state.chatContacts, chat_contact),
        ['last_message_time'],
        ['desc']
      );
    },
  },
});

export const {
  setContacts,
  setChatContacts,
  updateLastMessage,
  updateUnreadCount,
  appendNewContact,
  setActiveContacts,
  setArchivedContacts,
  setBlockedContacts,
} = contactsSlice.actions;

export default contactsSlice.reducer;
